import React, { ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { Flex, FormControl, FormControlProps, FormLabel, Switch } from '@tq/ui-components';
import { ComponentWithAs } from '@tq/ui-components/dist/system';

import { searchAssignedToMeState } from 'store';
import { useRecoilState } from 'recoil';

export const ConsultationShow: ComponentWithAs<'div', FormControlProps> = (props) => {
  const { t } = useTranslation('search_filter');
  const [assignedToMe, setAssignedToMe] = useRecoilState(searchAssignedToMeState);

  return (
    <FormControl {...props}>
      <FormLabel ml={3} id='show-assigned-label'>
        {t('show_title', 'Show')}
      </FormLabel>
      <Flex flexDirection='row'>
        <Switch
          className={assignedToMe ? 'checked' : 'unchecked'}
          aria-label={'show and hide assigned consultations switcher'}
          height='23px'
          margin='10px 0 0 0'
          data-testid='show-mine-switch'
          colorScheme='green'
          id='show-mine'
          isChecked={assignedToMe}
          orientation='vertical'
          bg='white'
          borderRadius={10}
          onChange={(e: ChangeEvent<HTMLInputElement>) => setAssignedToMe(e.target.checked)}
        />
        <Flex display='inline-flex' alignItems='left' flexDirection='column'>
          <FormLabel
            id='show-mine-switch-on'
            data-testid='show-mine-switch-on'
            margin={0}
            htmlFor='show-mine'
            fontSize='sm'
            lineHeight='20px'
            fontWeight={assignedToMe ? 'normal' : '700'}
          >
            {t('show_mine_all', 'All')}
          </FormLabel>
          <FormLabel
            id='show-mine-switch-off'
            data-testid='show-mine-switch-off'
            margin={0}
            htmlFor='show-mine'
            fontSize='sm'
            lineHeight='20px'
            fontWeight={assignedToMe ? '700' : 'normal'}
            whiteSpace='nowrap'
          >
            {t('show_mine', 'Assigned to me')}
          </FormLabel>
        </Flex>
      </Flex>
    </FormControl>
  );
};
